import { Attributes, AttributeValue } from './types';

/**
 * Removes the temporary ID (tmpId) from an attribute value if it exists.
 * If the attribute value doesn't have a tmpId property, returns the original value unchanged.
 *
 * @param {AttributeValue} attributeValue - The attribute value to process
 * @returns {AttributeValue} The attribute value without the tmpId property
 */
export const removeTmpId = (attributeValue: AttributeValue): AttributeValue => {
  if (!('tmpId' in attributeValue)) {
    return attributeValue;
  }
  const { tmpId: _, ...rest } = attributeValue;
  return rest;
};

/**
 * Adds temporary IDs (tmpId) to all attribute values in an attributes object.
 * The tmpId is set to the string representation of the value's index in its array.
 *
 * @param {Attributes} attributes - The attributes object to process
 * @returns {Attributes} A new attributes object with tmpId added to all values
 */
export const addTmpId = (attributes: Attributes): Attributes =>
  Object.fromEntries(
    Object.entries(attributes).map(([key, attribute]) => [
      key,
      {
        ...attribute,
        values: attribute.values.map((value, index) => ({
          ...value,
          tmpId: String(index),
        })),
      },
    ]),
  );
